import IconType from "@/components/IconType";
import Group from "@/tpo/Group";

export function ReportListCardHeader({
  iconType,
  iconSize = [40, 40, 80],
  topRightButton,
  color = "dark"
}) {
  return (
    <Group justifyContent="space-between" alignItems="center">
      <IconType iconType={iconType} iconSize={iconSize} withCircle color={color} />
      {topRightButton}
    </Group>
  );
}
